import { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Field,
  Input,
  Text,
} from "@fluentui/react-components";
import i18n from "i18next";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";
import { StackShim } from "@fluentui/react-migration-v8-v9";

interface IUserMediaEditDialogProps {
  userMediaGuid: string | undefined;
  onDismiss(): void;
  onSave(): void;
}

function UserMediaEditDialog(props: IUserMediaEditDialogProps) {
  const [editDto, setEditDto] = useState<any>();
  const handleEditDtoValuesChange = (name: string, val: any) => {
    setEditDto((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };

  const editUserMedia = (guid: string) => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/UserMedia/edit?id=${guid}`)
      .then((result) => {
        setEditDto(result);
      });
  };

  const editUserMediaConfirmed = () => {
    fetchWrapper
      .postWithAuth(`${baseUrl}/api/UserMedia/edit`, editDto)
      .then((result) => {
        setEditDto(undefined);
        props.onSave();
      });
  };

  useEffect(() => {
    if (props.userMediaGuid) {
      editUserMedia(props.userMediaGuid);
    }
  }, [props.userMediaGuid]);

  return (
    <Dialog modalType="modal" open={props.userMediaGuid != undefined}>
      <DialogTrigger disableButtonEnhancement></DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>{i18n.t<string>("editDocument")}</div>

              <Button
                onClick={() => {
                  props.onDismiss();
                }}
                appearance="transparent"
                icon={<Dismiss24Regular />}
              ></Button>
            </div>
          </DialogTitle>
          <DialogContent>
            <StackShim tokens={{ childrenGap: 10 }}>
              <Text>{i18n.t<string>("editDocumentText")}</Text>
              <Field label={i18n.t<string>("artikelId")}>
                <Input
                  appearance="filled-darker"
                  style={{ width: "100%" }}
                  value={
                    editDto?.customerMediatext ? editDto.customerMediatext : ""
                  }
                  onChange={(ev, data) => {
                    handleEditDtoValuesChange("customerMediatext", data.value);
                  }}
                />
              </Field>
            </StackShim>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={editDto ? !editDto.customerMediatext : false}
              appearance="primary"
              onClick={() => editUserMediaConfirmed()}
            >
              {i18n.t<string>("save")}
            </Button>

            <Button
              appearance="secondary"
              onClick={() => {
                setEditDto(undefined);
                props.onDismiss();
              }}
            >
              {i18n.t("cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
export default UserMediaEditDialog;
